// extracted by mini-css-extract-plugin
export default {"margin20":"NewPassword_margin20__fBJ1l","marginauto":"NewPassword_marginauto__c-FOs","success":"NewPassword_success__RG5Yk","success__inner":"NewPassword_success__inner__NZgCo"};